// extracted by mini-css-extract-plugin
module.exports = {"speech-bubble":"SpeechBubble_speech-bubble__8Of2_"};